import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=573ca470&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573ca470",
  null
  
)

export default component.exports